export const NO_CONDITION = '-1';
export const FULL_BODY_SITE = 'full-body-site';
